import { clsx } from 'clsx';
import classes from './Pagehead.module.css.js';
import { BoxWithFallback } from '../internal/components/BoxWithFallback.js';
import { jsx } from 'react/jsx-runtime';

const Pagehead = ({
  className,
  ...rest
}) => {
  return /*#__PURE__*/jsx(BoxWithFallback, {
    className: clsx(classes.Pagehead, className),
    ...rest
  });
};
Pagehead.displayName = "Pagehead";

export { Pagehead as default };
